import React, { useEffect, useState } from 'react';
import { Layout, Card, Select, Button, message, Modal, Upload } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import Sidebar from 'components/layout/Sidebar';
import Header from 'components/layout/Header';
import AllFilesTable from 'components/table/AllFilesTable';
import GoogleDriveApi from '../apiServices/GoogleDriveApi';
import axios from 'axios';
import apiEndPoints, { headers } from 'configs/endPoints';
import useWindowDimensions from 'data/useWindowDimensions';
import constants from 'data/constants';
import UploadOutlined from '@ant-design/icons/UploadOutlined';
import AntCloudOutlined from '@ant-design/icons/AntCloudOutlined';
import Loader from 'components/layout/Loader';

const FileUploadModal = (props) => {
	const [ modalVisisble, setModalVisisble ] = useState(false);
	const { visible, setVisible } = props;
	const { Dragger } = Upload;

	const handleOk = (e) => {
		console.log(e);
		setVisible(false);
	};

	const handleCancel = (e) => {
		console.log(e);
		setVisible(false);
	};

	const { Content } = Layout;
	const [ data, setData ] = useState([]);
	const [ selectedRowKeys, setSelectedRowKeys ] = useState([]);
	const [ ownerId, setOwnerId ] = useState([]);
	const [ isLoading, setIsLoading ] = useState(false);
	const { Option } = Select;
	const { width } = useWindowDimensions();
	const prop = {
		visible,
		name: 'file',
		multiple: true,
		action: 'https://contentlibraryapi.rivetsoftware.net/ContentLibraryBE/api/FileManager/UploadMultipleFileFromLocal',
		onChange(info) {
			const { status } = info.file;
			if (status !== 'uploading') {
				console.log(info.file, info.fileList);
			}
			if (status === 'done') {
				message.success(`${info.file.name} file uploaded successfully.`);
			} else if (status === 'error') {
				message.error(`${info.file.name} file upload failed.`);
			}
		}
	};

	useEffect(() => {
		axios
			.get(`${apiEndPoints.getAllFileFromContentLib}`, headers('accessToken'))
			.then((response) => {
				//	console.log(response.data.data);
				setData(response.data.data);
			})
			.catch((error) => {
				console.log(error);
			});
	}, []);

	useEffect(() => {
		axios
			.get(`${apiEndPoints.getAllDistinctOwnerIdFromContentLib}`, headers('accessToken'))
			.then((response) => {
				//console.log('setOwnerId', response.data.data);
				setOwnerId(response.data.data);
			})
			.catch((error) => {
				console.log(error);
			});
	}, []);

	//The Browser API key obtained from the Google API Console.
	// Replace with your own Browser API key, or your own key.
	var developerKey = 'AIzaSyAZKKE9Aqo0BkWXL9Lh14hYd1f1ciiAPZs';

	// The Client ID obtained from the Google API Console. Replace with your own Client ID.
	var clientId = '221719329929-vt17b8rsoq1ppepp0sc6cnij4294srbf.apps.googleusercontent.com';

	// Replace with your own project number from console.developers.google.com.
	// See "Project number" under "IAM & Admin" > "Settings"
	var appId = '221719329929';

	// Scope to use to access user's Drive items.
	const scope = [ 'https://www.googleapis.com/auth/drive.file' ];

	let pickerApiLoaded = false;
	var oauthToken;

	const showPickerDialog = () => {
		loadPicker();
	};

	// Use the Google API Loader script to load the google.picker script.
	let loadPicker = () => {
		window.gapi.load('auth', { callback: onAuthApiLoad });
		window.gapi.load('picker', { callback: onPickerApiLoad });
	};

	const onAuthApiLoad = () => {
		window.gapi.auth.authorize(
			{
				client_id: clientId,
				scope: scope,
				immediate: false
			},
			handleAuthResult
		);
	};

	let onPickerApiLoad = () => {
		pickerApiLoaded = true;
		createPicker();
	};

	const handleAuthResult = (authResult) => {
		if (authResult && !authResult.error) {
			oauthToken = authResult.access_token;
			createPicker();
		}
	};

	// Create and render a Picker object for searching images.
	const createPicker = () => {
		if (pickerApiLoaded && oauthToken) {
			const view = new window.google.picker.View(window.google.picker.ViewId.FOLDERS);
			view.setMimeTypes(
				'image/png,image/jpeg,image/jpg,application/pdf,application/zip,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
			);
			const picker = new window.google.picker.PickerBuilder()
				//.enableFeature(google.picker.Feature.NAV_HIDDEN)
				.enableFeature(window.google.picker.Feature.MULTISELECT_ENABLED)
				.setAppId(appId)
				.setOAuthToken(oauthToken)
				.addView(view)
				.addView(window.google.picker.ViewId.VIDEO_SEARCH)
				.addView(window.google.picker.ViewId.DOCUMENTS)
				.addView(window.google.picker.ViewId.PDFS)
				.addView(window.google.picker.ViewId.SPREADSHEETS)
				.addView(window.google.picker.ViewId.PRESENTATIONS)
				.addView(window.google.picker.ViewId.YOUTUBE)
				.addView(window.google.picker.ViewId.DOCS_VIDEOS)
				.addView(new window.google.picker.DocsUploadView())
				.setDeveloperKey(developerKey)
				.setCallback(pickerCallback)
				.build();
			picker.setVisible(true);
		}
	};

	// A simple callback implementation.
	const pickerCallback = (data) => {
		if (data.action == window.google.picker.Action.PICKED) {
			const fileId = data.docs;
			let dataFileId = [];
			for (let i = 0; i < fileId.length; i++) {
				const element = fileId[i].id;
				dataFileId.push(element);
				setIsLoading(true);
				axios
					.post(
						`${apiEndPoints.downloadGoogleDriveFileM}?userName=RivetAdmin`,
						dataFileId,
						headers('accessToken')
					)
					.then((response) => {
						setIsLoading(false);
						console.log('drte', response.data.description);
						message.success(response.data.description);
					})
					.catch((error) => {
						console.log(error);
					});
				//alert('The user selected: ' + element);
			}
			// listFiles(fileId);
			//   console.log('file', data.docs.length);
			//   console.log('dataFileId', dataFileId);
			//alert('The user selected: ' + fileId);
		}
	};

	const onSelectChange = (selectedRowKeys) => {
		console.log('selectedRowKeys changed: ', selectedRowKeys);
		setSelectedRowKeys(selectedRowKeys);
	};

	const rowSelection = {
		selectedRowKeys,
		onChange: onSelectChange
	};
	const hasSelected = selectedRowKeys.length > 0;

	return (
		<Modal
			destroyOnClose={true}
			title="Bulk Uploader"
			visible={visible}
			onOk={handleOk}
			onCancel={handleCancel}
			width={1000}
		>
			<div>
				<Card className="card-full">
					<Dragger {...prop}>
						<p className="ant-upload-drag-icon">
							<InboxOutlined />
						</p>
						<p className="ant-upload-text">Click or drag file to this area to upload</p>
						<p className="ant-upload-hint">
							Support for a single or bulk upload. Strictly prohibit from uploading company data or other
							band files
						</p>
					</Dragger>
				</Card>
				<p>
					<strong>Other ways to upload</strong>
				</p>
				<Select placeholder="Select OwnerId" allowClear required={true}>
					{ownerId &&
						ownerId.map((item) => (
							<Option key={item} value={item}>
								{item}
							</Option>
						))}
				</Select>
				<Button
					//	onClick={handleCreateAccountClick}
					onClick={showPickerDialog}
					type="primary"
					style={{ width: width < constants.PHONE_WIDTH ? '100%' : 'auto', marginLeft: 20 }}
				>
					<AntCloudOutlined />From Google Drive
				</Button>
				<Button
					//	onClick={handleCreateAccountClick}
					//onClick={showPickerDialog}
					type="primary"
					style={{ width: width < constants.PHONE_WIDTH ? '100%' : 'auto', marginLeft: 20 }}
				>
					<AntCloudOutlined />From OneDrive
				</Button>
				{/* <Card className="card-full" style={{ marginTop: 10, overflowX: 'visible' }}> */}
					<h3>
						<strong>Your uploaded files.</strong>
					</h3>
					<AllFilesTable data={data} />
				{/* </Card> */}
			</div>
		</Modal>
	);
};

export default FileUploadModal;
